document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('promo-modal');
  const closeBtn = document.getElementById('close-promo-modal');

  if (!modal || !closeBtn) {
    console.log('Missing promo modal or close button');
    return;
  }

  const targetTagsInput = document.querySelector('.target-tags');
  const productTagsInput = document.querySelector('.prod-tags');
  const compareAtInput = document.querySelector('.prod-compare');

  const targetTags = targetTagsInput?.value.split(',').map(tag => tag.trim()) || [];
  const productTags = productTagsInput?.value.split(',').map(tag => tag.trim()) || [];
  const compareAtPrice = compareAtInput?.value;

  const hasMatchingTag = productTags.some(tag => targetTags.includes(tag));
  const shouldShowPromo = hasMatchingTag && (compareAtPrice === 'null' || compareAtPrice === '' || compareAtPrice === null);

  //Listen for the cart update event that indicates a successful add-to-cart
  document.addEventListener('cart:updated', () => {
    if (shouldShowPromo) {
      modal.classList.remove('hidden');
    }
  });

  closeBtn.addEventListener('click', () => {
    modal.classList.add('hidden');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('promo-modal-2');
  const closeBtn = document.getElementById('close-promo-modal-2');

  if (!modal || !closeBtn) {
    console.log('Missing promo modal or close button');
    return;
  }

  const targetTagsInput = document.querySelector('.target-tags-2');
  const productTagsInput = document.querySelector('.prod-tags');
  const compareAtInput = document.querySelector('.prod-compare');

  const targetTags = targetTagsInput?.value.split(',').map(tag => tag.trim()) || [];
  const productTags = productTagsInput?.value.split(',').map(tag => tag.trim()) || [];
  const compareAtPrice = compareAtInput?.value;

  const hasMatchingTag = productTags.some(tag => targetTags.includes(tag));
  const shouldShowPromo = hasMatchingTag && (compareAtPrice === 'null' || compareAtPrice === '' || compareAtPrice === null);

  //Listen for the cart update event that indicates a successful add-to-cart
  document.addEventListener('cart:updated', () => {
    if (shouldShowPromo) {
      modal.classList.remove('hidden');
    }
  });

  closeBtn.addEventListener('click', () => {
    modal.classList.add('hidden');
  });
});
